import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import { useState } from 'react'
import EditIdea from '../pages/editIdea'
import AddToDeckComp from './addToDeckComp'
import RatingComp from './ratingComp'


const IdeaComp = (props) => {
    const idea = props.mods.value
    const getIdeas = props.mods.getIdeas
    const user = props.mods.user

    const [detailsToggle, setDetailsToggle] = useState(false)
    const [editToggle, setEditToggle] = useState(false)
    const [addToDeckToggle, setAddToDeckToggle] = useState(false)

    function handleDetailsToggle() {
        if (detailsToggle) {
            setDetailsToggle(false)
        } else {
            setDetailsToggle(true)
        }
    }

    function handleEditToggle() {
        if (editToggle === true) {
            setEditToggle(false)
        } else {
            setEditToggle(true)
        }
    }

    function handleAddToDeck() {
        if(addToDeckToggle === false) {
            setAddToDeckToggle(true)
        } else {
            setAddToDeckToggle(false)
        }
    }

    function handleRate() {
        
    }

    return (
        <div className="ideaItem ideaContainer">
                {(!editToggle && addToDeckToggle) ? <AddToDeckComp mods={{idea, setAddToDeckToggle}} /> : null }
                {!editToggle ? <>
                    <Row>
                        <Col>
                            <h4>{idea.name}</h4>
                            <h6>Location: {idea.location}</h6>
                       {!detailsToggle ? <p type="button" className="bottomCenter" onClick={handleDetailsToggle}>more<i className="bi bi-chevron-compact-down"></i></p> : null}
                        </Col>
                        <Col>
                            <RatingComp mods={{idea, getIdeas}} />
                        </Col>
                        <Col>
                            <Button onClick={handleAddToDeck} className="btn-dark defaultButton">Add to Deck</Button>
                        </Col>
                    </Row>
                    {detailsToggle ? 
                        <>
                            <Row>
                                <Col><p>Details: {idea.details}</p></Col>
                                <Col>
                                    {(idea.owner === user._id) ?
                                    <Button onClick={handleEditToggle} className="btn-dark defaultButton editButton">Edit</Button>  : null }
                                    <p type="button" className="bottomCenter" onClick={handleDetailsToggle}>less<i className="bi bi-chevron-compact-up"></i></p>
                                </Col>
                            </Row>
                        
                        </>
                        : null
                    } </>
                : <EditIdea mods={{idea, getIdeas, setEditToggle}} />
                }
                </div>
    )
}

export default IdeaComp